import {SaleVehiclePromoPhotoResponseBody} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

// A promo item whose render exists; a FINANCING card that is not READY yet has no file and is
// explained by the financing status instead of being shown as an image.
export type RenderedOwnPromoPhoto = SaleVehiclePromoPhotoResponseBody & {
  fileId: string;
  remoteFileId: string;
  url: string;
};

export const toUnifiedOwnPromoPhoto = (photo: RenderedOwnPromoPhoto): UnifiedAlbumImage => ({
  ...photo,
  url: photo.url.replace('/get/', '/resize/'),
  isCoverPhoto: false,
  isPromoPhoto: true,
  isCampaignPhoto: false,
  latestFileOperation: null,
  weight: photo.position,
});
